import { useI18n } from "../i18n/index.ts";

export interface AddButtonProps {
  readonly onClick: () => void;
  /**
   * Masqué pendant qu'un panneau est ouvert, mais **conservé dans le flux** :
   * le retirer faisait sauter la largeur de la barre de recherche à chaque
   * ouverture. `visibility` le retire aussi de l'arbre d'accessibilité et du
   * parcours au clavier.
   */
  readonly hidden?: boolean;
}

/**
 * Point d'entrée unique de la création. Un bouton explicite plutôt qu'un geste
 * sur la carte : toucher la carte est le geste de navigation, et l'y greffer une
 * action modale ouvrait une feuille à chaque tap involontaire.
 */
export const AddButton = (props: AddButtonProps): React.ReactElement => {
  const { t } = useI18n();

  return (
    <button
      type="button"
      className={`fab ${props.hidden === true ? "fab--hidden" : ""}`}
      onClick={props.onClick}
    >
      <span className="fab__glyph" aria-hidden="true">
        +
      </span>
      <span className="fab__label">{t.add.label}</span>
    </button>
  );
};
